import useFetch from '../../hooks/useFetch'
import { useState, useEffect } from 'react'
import { urlApi } from '../../config'
import Alert from '../Alert'
import LoadingIndicator from '../LoadingIndicator'

export default function AddSeats({ lobby, companion, seatsToAdd, onClose, handleSuccess }) {
  const [alert, setAlert] = useState(true)
  const { loading, responseOk } = useFetch(`${urlApi}/admin/lobbies/add-seats/${lobby._id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      user_id: companion.user_id,
      seats: seatsToAdd
    })
  })

  useEffect(() => {
    if (!loading && responseOk !== null) {
      if (responseOk) {
        window.alert('Asientos agregados con éxito')
        handleSuccess()
      } else {
        window.alert('Error al agregar asientos')
      }
      setAlert(false)
    }
  }, [loading, responseOk])

  return (
    <Alert
      visible={alert}
      onClose={() => {
        setAlert(false)
        if (onClose) onClose()
      }}
      hideButton={loading}
    >
      <div className='flex justify-center items-center h-full'>
        {loading && <LoadingIndicator />}
      </div>
    </Alert>
  )
}
